<div class="row g-2">
  <div class="col-12" *ngFor="let option of options; let i=index">
    <app-registration-option
      [option]="option"
      [optionForm]="optionsForm.controls[i]">
    </app-registration-option>
  </div>
</div>
